export default __webpack_public_path__ + "static/media/qrcode-colored.ec7a4477.svg";